"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LifeInsurancePageThree;
exports.scenarioIncludesAtLeastOneChildUnder14 = scenarioIncludesAtLeastOneChildUnder14;
var _react = _interopRequireDefault(require("react"));
var _CollapseInfo = _interopRequireDefault(require("../Wizard/CollapseInfo"));
var _formik = require("formik");
var _utils = require("../../middleware/utils");
var _LifeInsuranceRefineModal = _interopRequireDefault(require("./LifeInsuranceRefineModal"));
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function LifeInsurancePageThree(props) {
  var _resp$PV_Income_Needs, _resp$PV_HealthCare_C, _resp$PV_Personal_Exp, _resp$TotalLifeInsura, _resp$PresentValueOfN, _resp$ImmediateNeeds;
  var {
    apiData,
    refinementHandleClose,
    snapshot,
    showRefinement,
    fetchDataScienceResults,
    disclosureHandleClose,
    showDisclosure
  } = props;
  var resp = apiData === null || apiData === void 0 ? void 0 : apiData.data;
  var {
    values: {
      collegeTerm,
      mortgageAmount,
      otherDebt,
      collegePlanInd,
      beneficiary,
      spouseIncome
    },
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    // We might be able to use setValues instead of looping through.
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var contentArray1 = [{
    label: 'Income replacement',
    value: (0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$PV_Income_Needs = resp.PV_Income_Needs) === null || _resp$PV_Income_Needs === void 0 ? void 0 : _resp$PV_Income_Needs[0]),
    id: 'incomeReplacement'
  }, {
    label: 'Health & personal care',
    value: (0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$PV_HealthCare_C = resp.PV_HealthCare_Cost) === null || _resp$PV_HealthCare_C === void 0 ? void 0 : _resp$PV_HealthCare_C[0]),
    id: 'healthPersonalCare'
  }];
  if (scenarioIncludesKids(beneficiary) && scenarioIncludesAtLeastOneChildUnder14(values)) {
    var _resp$PV_ChildCare_Co;
    contentArray1.push({
      label: 'Child care',
      value: (0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$PV_ChildCare_Co = resp.PV_ChildCare_Cost) === null || _resp$PV_ChildCare_Co === void 0 ? void 0 : _resp$PV_ChildCare_Co[0]),
      id: 'childCare'
    });
  }
  if (scenarioIncludesKids(beneficiary) && scenarioPlansForCollege(collegePlanInd)) {
    var _resp$PV_College_Cost;
    contentArray1.push({
      label: 'College cost',
      value: (0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$PV_College_Cost = resp.PV_College_Cost) === null || _resp$PV_College_Cost === void 0 ? void 0 : _resp$PV_College_Cost[0]),
      id: 'collegeCost'
    });
    contentArray1.push({
      label: 'College fund',
      value: (0, _utils.titleCase)(collegeTerm),
      id: 'collegeFund'
    });
  }
  contentArray1.push({
    label: 'Personal expenses ',
    value: "(".concat((0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$PV_Personal_Exp = resp.PV_Personal_Expense) === null || _resp$PV_Personal_Exp === void 0 ? void 0 : _resp$PV_Personal_Exp[0]), ")"),
    id: 'personalExpenses'
  });
  if (scenarioInlcudesSpouseWithIncome(beneficiary, spouseIncome)) {
    var _resp$PV_Spouse_Incom;
    contentArray1.push({
      label: "Spouse's Income ",
      value: "(".concat((0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$PV_Spouse_Incom = resp.PV_Spouse_Income) === null || _resp$PV_Spouse_Incom === void 0 ? void 0 : _resp$PV_Spouse_Incom[0]), ")"),
      id: 'spouseIncome',
      popoverText: "Including spouse's income reduces recommended coverage.",
      popoverId: 'spouseIncome'
    });
  }
  var contentArray2 = [{
    label: 'Burial costs',
    value: (0, _utils.numberToCurrencyString)(values === null || values === void 0 ? void 0 : values.burialCost),
    id: 'burialCost'
  },
  // Since we are pulling values (mortgage and otherDebt) straight from formik context, the values will be strings with commas
  // We need to convert them to pure numbers before applying the numberToCurrencyString method
  {
    label: 'Mortgage costs',
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, mortgageAmount)),
    id: 'mortgageCost'
  }, {
    label: 'Other debts',
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, otherDebt)),
    id: 'otherDebts'
  }];
  var disclosureArray = ['This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. All projections are hypothetical in nature, do not reflect actual results, and are not guarantees of future results. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.', 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York.'];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "data-lg"
  }, (0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$TotalLifeInsura = resp.TotalLifeInsuranceNeeded) === null || _resp$TotalLifeInsura === void 0 ? void 0 : _resp$TotalLifeInsura[0])), !scenarioIsJustMe(beneficiary) ? /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: generateTitleText(beneficiary, collegePlanInd),
    total: (0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$PresentValueOfN = resp.PresentValueOfNetNeeds) === null || _resp$PresentValueOfN === void 0 ? void 0 : _resp$PresentValueOfN[0]),
    id: "lostIncomeEtc",
    contentArray: contentArray1
  }) : null, /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: "Burial costs, mortgage, and other debt",
    total: (0, _utils.numberToCurrencyString)(resp === null || resp === void 0 || (_resp$ImmediateNeeds = resp.ImmediateNeeds) === null || _resp$ImmediateNeeds === void 0 ? void 0 : _resp$ImmediateNeeds[0]),
    id: "burialCostEtc",
    contentArray: contentArray2
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceRefineModal.default, {
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot,
    show: showRefinement,
    fetchDataScienceResults: fetchDataScienceResults,
    apiData: apiData
  }), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    textArray: disclosureArray,
    handleClose: disclosureHandleClose,
    show: showDisclosure
  }));
}
function scenarioIncludesKids(beneficiary) {
  return beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids';
}
function scenarioPlansForCollege(collegePlanInd) {
  return collegePlanInd == 'plan';
}
function scenarioIsJustMe(beneficiary) {
  return beneficiary == 'just me';
}
function scenarioInlcudesSpouseWithIncome(beneficiary, spouseIncome) {
  return (beneficiary == 'my spouse/partner & kids' || beneficiary == 'my spouse/partner') && parseInt(spouseIncome) > 0;
}
function scenarioIncludesAtLeastOneChildUnder14(values) {
  // only loop through children they are claiming
  for (var i = 1; i <= values.numOfKids; i++) {
    // If child age is not "" and the number is less than or equal to 14 return true
    if (values["child".concat(i, "Age")] != '' && values["child".concat(i, "Age")] <= 14) {
      return true;
    }
  }
  return false;
}
function generateTitleText(beneficiary, collegePlanInd) {
  if (beneficiary == 'just me' || beneficiary == 'a dependent adult' || beneficiary == 'my spouse/partner') {
    return 'Lost income, estimated health, and personal care costs';
  } else if ((beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && collegePlanInd == 'plan') {
    return 'Lost income, estimated health, child care, and college costs';
  } else if ((beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && collegePlanInd == "do not plan") {
    return 'Lost income, estimated health, and child care costs';
  }
}